import * as React from 'react';
import { FormattedMessage } from 'react-intl/dist';
import GIButton from '../../components/common/button/GIButton';
import ModalHeader from '../../components/common/headers/ModalHeader';
import styled from 'styled-components';

interface IExemptionNumberModalProps {
  modalHeaderProps: {
    title: string;
    subtitle?: string;
    [key: string]: any;
  };
  actions: {
    hideModal: () => void;
  };
}

const ExemptionNumberModal: React.FC<IExemptionNumberModalProps> = ({ modalHeaderProps, actions: { hideModal } }) => {
  const handleCloseModal = () => hideModal();
  return(
    <>
      <div className="exemption-number__modal-header">
        <ModalHeader { ...{ ...modalHeaderProps }} />
      </div>
      <div className="grid-container">
        <div className="gi-modal__body">
          <FormattedMessage id='indportal.tobacco.noHardshipExemptNo.modal.content' />
        </div>
      </div>
      <div className="gi-modal__controls">
        <GIButton id='button.close' labelId='button.close' variant='secondary' onClickHandler={ handleCloseModal }></GIButton>
      </div>
    </>

  )
};

export default ExemptionNumberModal;